import styled from 'styled-components';
import cssKit from '../../css';

const nissan = process.env.BRAND_NAME === 'nissan';

export const StyledLocationWrapper = styled.div`
  font-size: 14px;
  float: left;
  border-top: 1px solid #d3d3d3;
  margin-top: 10px;
  clear: both;
  padding: 10px 20px 10px 3px;

  ${cssKit.media.greaterThan('small') `
    border-top: none;
    margin-top: 0;
    float: right;
    padding-top: 0;
    padding-left: 0;
    clear: none !important;
  `};
`;

export const StyledLocationLabel = styled.span`
  text-transform: uppercase;
`;

export const StyledOpenLocationButton = styled.button`
  text-decoration: underline;
  font-weight: ${nissan ? 'normal' : 'bold'};
  height: 20px;
  color: ${nissan ? '#333333' : '#000'};
`;



/** WEBPACK FOOTER **
 ** ./src/components/Location/styles.js
 **/